import { LegalChrome } from './LegalChrome';
import { MAILING_ADDRESS, SUPPORT_EMAIL } from './constants';

export function DeleteAccountPage() {
  const subject = encodeURIComponent('Kynward account deletion request');
  const body = encodeURIComponent(
    [
      'I want to delete my Kynward account and associated data.',
      '',
      'Email or phone on my account:',
      '',
      'Username (if any):',
      '',
      '(Add any details we need to find your account.)',
    ].join('\n')
  );
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

  return (
    <LegalChrome>
      <h1 className="legal-h1">Delete your Kynward account</h1>

      <p className="legal-p">
        If you want to delete your Kynward account and associated data, you can do so in either of
        the following ways:
      </p>

      <h2 className="legal-h2">In the app</h2>
      <p className="legal-p">
        Open Kynward and go to:
        <br />
        <br />
        Settings → Account → Delete account
      </p>

      <h2 className="legal-h2">On the web</h2>
      <p className="legal-p">
        If you no longer have access to the app or prefer to make the request here, you can request
        account deletion by contacting us at:
      </p>
      <p className="legal-p">
        <a className="legal-a" href={`mailto:${SUPPORT_EMAIL}`}>
          {SUPPORT_EMAIL}
        </a>
      </p>

      <p className="legal-p">Please include:</p>
      <ul className="legal-ul">
        <li className="legal-li">the email address or phone number associated with your account</li>
        <li className="legal-li">your Kynward username, if available</li>
        <li className="legal-li">a statement that you want your account deleted</li>
      </ul>

      <p className="legal-p">
        We may ask you to verify your identity before completing the request.
      </p>

      <a
        className="legal-btn"
        href={mailto}
        style={{ display: 'inline-block', textDecoration: 'none' }}>
        Request deletion by email
      </a>
      <p className="legal-hint">
        Opens your email app with a draft you can edit. You can also email {SUPPORT_EMAIL} from any
        device.
      </p>

      <h2 className="legal-h2">What happens when your account is deleted</h2>
      <p className="legal-p">
        When your deletion request is completed, we will delete or de-identify your Kynward account
        and associated personal information within a reasonable period, except where we need to
        retain limited information for legitimate business or legal reasons, such as:
      </p>
      <ul className="legal-ul">
        <li className="legal-li">fraud prevention and security</li>
        <li className="legal-li">abuse prevention and safety enforcement</li>
        <li className="legal-li">payment, tax, and accounting obligations</li>
        <li className="legal-li">dispute resolution</li>
        <li className="legal-li">legal compliance</li>
      </ul>
      <p className="legal-p">
        Please note that content you previously shared with other users may remain visible to them,
        and limited backup copies may persist for a short period until overwritten in the ordinary
        course.
      </p>

      <h2 className="legal-h2">Need help?</h2>
      <p className="legal-p">
        If you have trouble deleting your account, contact:
        <br />
        <br />
        Elyxora Works, LLC
        <br />
        {SUPPORT_EMAIL}
        <br />
        {MAILING_ADDRESS}
      </p>
    </LegalChrome>
  );
}
